/** @jsx jsx */
import React from 'react'
import FastClick from 'react-fastclick-alt'
import ReactDOM from 'react-dom'
import { configure } from 'mobx'
import { Global, css, jsx } from '@emotion/core'

import App from '@shared/App'
import registerServiceWorker from './sw'
import _ from 'lodash'
import { isMobile, isIOS } from 'react-device-detect'
import { throttle } from 'rmc-list-view/es/util'
import AOS from 'aos'
import 'aos/dist/aos.css'

// import './index.css'
registerServiceWorker()
configure({ enforceActions: 'observed' })

const antMobileListViewScrollListener = throttle()

const isAntMobileListViewScrollListener = (type, listener): boolean => {
  if (!isMobile) {
    return false
  }

  if (type !== 'scroll') {
    return false
  }

  if (listener
    && listener.name === antMobileListViewScrollListener.name
    && listener.toString() === antMobileListViewScrollListener.toString()) {
    return true
  }
  return false
}

const render = (Component: React.ComponentType) => {
  console.timeEnd('Mobx store initializing - App index start')
  console.time('App index start - PrimaryLayout render start')

  if (isIOS) {
    AOS.init()
  }

  window.antMobileListViewScrollListeners = []

  const originalWindowAddEventListener = Window.prototype.addEventListener
  Window.prototype.addEventListener = (type, listener, options) => {
    if (isAntMobileListViewScrollListener(type, listener)) {
      const foundListener = _.find(window.antMobileListViewScrollListeners,
        savedListener => savedListener === listener)
      if (!foundListener) {
        window.antMobileListViewScrollListeners.push(listener)
      }
    }
    originalWindowAddEventListener.call(this, type, listener, options)
  }

  const originalWindowRemoveEventListener = Window.prototype.removeEventListener
  Window.prototype.removeEventListener = (type, listener, options) => {
    if (isAntMobileListViewScrollListener(type, listener)) {
      const index = _.findIndex(window.antMobileListViewScrollListeners, savedListener => savedListener === listener)
      _.pullAt(window.antMobileListViewScrollListeners, [index])
    }
    originalWindowRemoveEventListener.call(this, type, listener, options)
  }

  window.removeDuplicateAntMobileListViewScrollListeners = (onMount = false) => {
    if (!isMobile) {
      return
    }

    let length = _.size(window.antMobileListViewScrollListeners)
    if (onMount) {
      length = length - 1
    }

    for (let i = 0; i < length; i += 1) {
      window.removeEventListener('scroll', window.antMobileListViewScrollListeners[i])
    }

    if (onMount) {
      window.antMobileListViewScrollListeners = [window.antMobileListViewScrollListeners[length]]
    } else {
      window.antMobileListViewScrollListeners = []
    }
  }

  ReactDOM.render(
    <FastClick>
      <Component>
        <Global
          styles={css`
            html,
            body {
              /* font-family: 'Noto Sans KR' !important; */
              width: 100%;
              height: 100%;
            }

            #app {
              display: flex;
              position: relative;
              width: 100%;
              height: 100%;
              flex-direction: column;
            }

            svg,
            svg path {
              fill: currentcolor;
            }

            .center-table {
              table td {
                text-align: center;
              }

              .ant-table-thead > tr > th {
                text-align: center;
              }
            }
          `}
        />
      </Component>
    </FastClick>,
    document.getElementById('app'),
  )
  // ReactDOM.render(<Component />, document.getElementById('app'))
}

render(App)
